import ProtectedRoute from "../../auth/ProtectedRoute";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import React, { Suspense, useEffect, useState } from "react";
import Forum from "../../pages/Forum";
import Planning3 from "../../planning/Planning3";
import FolderPortal from "../../portal/FolderPortal";
import NewFeatures from "../../pages/NewFeatures";
import Assistant from "../../pages/Assistant";
import MasterStats from "../../pages/home/MasterStats";
import Masters from "../../pages/Masters";
import Messages from "../../messages/Messages";
import { useAuth } from "../../auth/FirebaseAuth";
import { useAppContext } from "../AppContext";
import { getDocDataById, getDocDataByRef } from "../../models/DataFunctions";
import { Spin } from "antd";
import Payments from "../../pages/Payments";
import AdminRoutes from "./AdminRoutes";
import { data } from "autoprefixer";
import ParametersNavBar from "../../hexagone/ParametersNavBar";
import BookShelf from "../../pages/parameters/BookShelf";
import WaitingDisplay from "../../modals/WaitingDisplay";
import WaitingDisplay2 from "../../modals/WaitingDisplayFavoris";
import Partners from "../../pages/Partners";
import ModifyPartner from "../../pages/ModifyPartner";
import Partner from "../../pages/Partner";
import NewPartner from "../../pages/NewPartner";
const FolderV2 = React.lazy(
  () => import("../../pages/folder_pages/FolderV2"),
);
import NewInvoiceDraft from "../../pages/NewInvoiceDraft";
import NewInvoiceFromDraft from "../../pages/NewInvoiceFromDraft";
import PlanningRDV from "../../planning/rdv/PlanningRDV";
import SmallSpinner from "../../loading/SmallSpinner";
import Payment from "../../pages/Payment";
import ModifyPayment from "../../pages/folder_pages/ModifyPayment";

const Entree = React.lazy(() => import("../../pages/Entree"));
const Home = React.lazy(() => import("../../pages/home/Home"));
const Login = React.lazy(() => import("../../pages/Login"));
const Redirect = React.lazy(() => import("../../pages/Redirect"));
const NavBar = React.lazy(() => import("../../hexagone/NavBar"));
const Row = React.lazy(() => import("../../layout/Row"));
const HeaderBar = React.lazy(() => import("../../hexagone/HeaderBar"));

const NewDemand = React.lazy(
  () => import("../../pages/folder_pages/NewDemand")
);
const Setup = React.lazy(() => import("../../pages/Setup"));
const InvoiceSign = React.lazy(() => import("../../portal/InvoiceSign"));
const Signin = React.lazy(() => import("../../pages/Signin"));
const Users = React.lazy(() => import("../../pages/admin/Users"));
const User = React.lazy(() => import("../../pages/admin/User"));
const NotFound = React.lazy(() => import("../../pages/NotFound"));

// Lazy-lo
const Folders = React.lazy(() => import("../../pages/folder_pages/Folders"));
const EmailsSync = React.lazy(() => import("../../pages/EmailsSync"));
const NewFolder = React.lazy(
  () => import("../../pages/folder_pages/NewFolder")
);
const ModifyFolder = React.lazy(
  () => import("../../pages/folder_pages/ModifyFolder")
);
const Parameters = React.lazy(
  () => import("../../pages/parameters/Parameters")
);
const Orgs = React.lazy(() => import("../../pages/admin/Orgs"));
const Org = React.lazy(() => import("../../pages/admin/Org"));
const Logs = React.lazy(() => import("../../pages/admin/Logs"));
const Invoices = React.lazy(() => import("../../pages/Invoices"));
const Invoice = React.lazy(() => import("../../pages/Invoice"));
const StripeSuccess = React.lazy(() => import("../../pages/StripeSuccess"));

const OldRoutes = ({
  navigateWorkspace,
  actualpage,
  version,
  userData,
  orgData,
  masterData,
  workspaceData,
  handleLoginAs,
  stripeConnectInstance,
  refreshFolders,
}) => {
  const location = useLocation();

  const navigate = useNavigate(); // Hook to handle navigation
  const { currentUser, loading } = useAuth();

  const { appState, setAppState, filter, setFilter, setEventFilter } =
    useAppContext();
  const saved_data = appState.saved_data;
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  function overrideId() {
    // find the workspace id from the URL
    const path = location.pathname.split("/");
    const workspaceIndex = path.indexOf("imp");
    if (workspaceIndex !== -1) {
      return path[workspaceIndex + 1];
    } else {
      return null;
    }
  }

  let isinparameters = actualpage === "parameters";
  const [old_pathname, setOldPathname] = useState(location.pathname);
  useEffect(() => {
    if (location.pathname !== old_pathname) {
      setOldPathname(location.pathname);

      refreshFolders(location.pathname.includes("folder"));
    }
  }, [location.pathname, refreshFolders]);

  function workspaceId() {
    // find the workspace id from the URL
    const path = location.pathname.split("/");
    const workspaceIndex = path.indexOf("workspace");
    if (workspaceIndex !== -1) {
      return path[workspaceIndex + 1];
    } else {
      return null;
    }
  }
  const show_favoris = useState(Math.random() > 0.5)[0];
  let loading_text = !userData
    ? "Chargement de l'utilisateur"
    : !orgData
      ? "Chargement de l'organisation"
      : saved_data?.events === undefined && !workspaceData
        ? "Chargement des évènements"
        : "Chargement des données";

  if (
    loading ||
    !userData ||
    !orgData ||
    !orgData.ref ||
    (saved_data?.events === undefined && !workspaceData)
  ) {
    return (
      <div className="h-screen flex flex-col gap-2 bg-white fixed w-screen overflow-hidden items-center justify-center">
        <SmallSpinner />
        <div className="text-h3 text-shadow_25 mt-4">{loading_text}</div>
        {show_favoris ? (
          <WaitingDisplay
            title="Posez vos questions via le chat"
            subtitle="Nous sommes là pour vous aider (questions sur hexagone & bugs)"
          ></WaitingDisplay>
        ) : (
          <WaitingDisplay2
            title="Ajoutez hexagone à vos favoris"
            subtitle="Pour un accès rapide à votre espace de travail"
          ></WaitingDisplay2>
        )}
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full w-full ">
      <Routes>
        <Route
          path={"/home"}
          element={
            <Home
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              workspaceData={workspaceData}
              overrideId={overrideId()}
            />
          }
        />
        <Route
          path={"/partners"}
          element={
            <Partners
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              workspaceData={workspaceData}
            />
          }
        />
        <Route
          path={"/stats"}
          element={
            <MasterStats
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              workspaceData={workspaceData}
            />
          }
        />
        <Route
          path={"/masters"}
          element={
            <Masters
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              workspaceData={workspaceData}
            />
          }
        />
        <Route
          path={"/newpartner"}
          element={
            <NewPartner
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              workspaceData={workspaceData}
            />
          }
        />
        <Route
          path={"/modifypartner/:id"}
          element={
            <ModifyPartner
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              workspaceData={workspaceData}
            />
          }
        />
        <Route
          path={"/partner/:id"}
          element={
            <Partner
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              refreshFolders={refreshFolders}
              workspaceData={workspaceData}
            />
          }
        />
        <Route
          path={"/folders"}
          element={
            <Folders
              userData={userData}
              orgData={orgData}
              overrideId={overrideId()}
              navigateWorkspace={navigateWorkspace}
              refreshFolders={refreshFolders}
              workspaceData={workspaceData}
              masterData={masterData}
            />
          }
        />
        <Route
          path={"/emails-sync"}
          element={
            <EmailsSync
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
            />
          }
        />
        <Route
          path={"/whats-new"}
          element={
            <NewFeatures
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              workspaceData={workspaceData}
            />
          }
        />
        <Route
          path={"/newfolder"}
          element={
            <NewFolder
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              workspaceData={workspaceData}
              masterData={masterData}
            />
          }
        />
        <Route
          path={"/newdemand"}
          element={
            <NewDemand
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              workspaceData={workspaceData}
              masterData={masterData}
            />
          }
        />
        <Route
          path={"/newdemandpartner"}
          element={
            <NewDemand
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              workspaceData={workspaceData}
              masterData={masterData}
              isPartner={true}
            />
          }
        />
        <Route
          path={"/modifyfolder/:id"}
          element={
            <ModifyFolder
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              workspaceData={workspaceData}
              masterData={masterData}
            />
          }
        />{" "}
        <Route
          path={"/modifypayment/:id"}
          element={
            <ModifyPayment
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              workspaceData={workspaceData}
              masterData={masterData}
            />
          }
        />
        <Route
          path={"/folder/:id"}
          element={
            <FolderV2
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              overrideId={overrideId()}
              workspaceData={workspaceData}
              masterData={masterData}
            />
          }
        />
        <Route
          path={"/planning"}
          element={
            <Planning3
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              overrideId={overrideId()}
              workspaceData={workspaceData}
              masterData={masterData}
            />
          }
        />
        <Route
          path={"/planning-rdv"}
          element={
            <PlanningRDV
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              overrideId={overrideId()}
              workspaceData={workspaceData}
              masterData={masterData}
            />
          }
        />
        <Route
          path="/payments"
          element={
            <Payments
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              workspaceData={workspaceData}
            />
          }
        />
        <Route
          path="/payment/:id"
          element={
            <Payment
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              workspaceData={workspaceData}
            />
          }
        />
        <Route
          path={"/parameters"}
          element={
            <Parameters
              page="Account"
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              overrideId={overrideId()}
              workspaceData={workspaceData}
              masterData={masterData}
            />
          }
        />
        <Route
          path={"/account"}
          element={
            <Parameters
              page="Account"
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              overrideId={overrideId()}
              workspaceData={workspaceData}
              masterData={masterData}
            />
          }
        />
        <Route
          path={"/organisation"}
          element={
            <Parameters
              page="Organisation"
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              refreshFolders={refreshFolders}
              overrideId={overrideId()}
              workspaceData={workspaceData}
              masterData={masterData}
            />
          }
        />
        <Route
          path={"/devisparams"}
          element={
            <Parameters
              page="DevisParams"
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              overrideId={overrideId()}
              workspaceData={workspaceData}
              masterData={masterData}
            />
          }
        />{" "}
        <Route
          path={"/controlparams"}
          element={
            <Parameters
              page="ControlParams"
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              overrideId={overrideId()}
              workspaceData={workspaceData}
              masterData={masterData}
            />
          }
        />{" "}
        <Route
          path={"/gallery"}
          element={
            <Parameters
              page="Gallery"
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              overrideId={overrideId()}
              workspaceData={workspaceData}
              masterData={masterData}
            />
          }
        />{" "}
        <Route
          path={"/widget"}
          element={
            <Parameters
              page="Widget"
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              overrideId={overrideId()}
              workspaceData={workspaceData}
              masterData={masterData}
            />
          }
        />{" "}
        <Route
          path={"/formparams"}
          element={
            <Parameters
              page="FormParams"
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              workspaceData={workspaceData}
              masterData={masterData}
            />
          }
        />
        <Route
          path={"/invitemanager"}
          element={
            <Parameters
              page="InviteManager"
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              overrideId={overrideId()}
              workspaceData={workspaceData}
              masterData={masterData}
            />
          }
        />
        <Route
          path={"/reminders"}
          element={
            <Parameters
              page="Reminders"
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              overrideId={overrideId()}
              workspaceData={workspaceData}
              masterData={masterData}
            />
          }
        />
        <Route
          path={"/facturation"}
          element={
            <Parameters
              page="Facturation"
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              overrideId={overrideId()}
              workspaceData={workspaceData}
              masterData={masterData}
            />
          }
        />
        <Route
          path={"/mobileapp"}
          element={
            <Parameters
              page="MobileApp"
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              overrideId={overrideId()}
              workspaceData={workspaceData}
              masterData={masterData}
            />
          }
        />
        <Route
          path={"/rdvparams"}
          element={
            <Parameters
              page="RDVManager"
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              stripeConnectInstance={stripeConnectInstance}
              overrideId={overrideId()}
              workspaceData={workspaceData}
              masterData={masterData}
            />
          }
        />
        <Route
          path={"/bridge"}
          element={
            <Parameters
              page="Bridge"
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              stripeConnectInstance={stripeConnectInstance}
              overrideId={overrideId()}
              workspaceData={workspaceData}
              masterData={masterData}
            />
          }
        />
        <Route
          path={"/cil"}
          element={
            <Parameters
              page="CIL"
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              stripeConnectInstance={stripeConnectInstance}
              overrideId={overrideId()}
              workspaceData={workspaceData}
              masterData={masterData}
            />
          }
        />
        <Route
          path={"/infiltrea"}
          element={
            <Parameters
              page="Infiltrea"
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              overrideId={overrideId()}
              workspaceData={workspaceData}
              masterData={masterData}
            />
          }
        />
        <Route
          path={"/pennylane"}
          element={
            <Parameters
              page="Pennylane"
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              overrideId={overrideId()}
              workspaceData={workspaceData}
              masterData={masterData}
            />
          }
        />{" "}
        <Route
          path={"/google-calendar"}
          element={
            <Parameters
              page="GoogleCalendar"
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              overrideId={overrideId()}
              workspaceData={workspaceData}
              masterData={masterData}
            />
          }
        />
        <Route
          path={"/agenda"}
          element={
            <Parameters
              page="Agenda"
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              overrideId={overrideId()}
              workspaceData={workspaceData}
              masterData={masterData}
            />
          }
        />
        <Route
          path={"/rtb"}
          element={
            <Parameters
              page="RTB"
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              overrideId={overrideId()}
              workspaceData={workspaceData}
              masterData={masterData}
            />
          }
        />
        <Route
          path={"/documents"}
          element={
            <Parameters
              page="Documents"
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              overrideId={overrideId()}
              workspaceData={workspaceData}
              masterData={masterData}
            />
          }
        />
        <Route
          path={"/xml"}
          element={
            <Parameters
              page="XML"
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              overrideId={overrideId()}
              workspaceData={workspaceData}
              masterData={masterData}
            />
          }
        />
        <Route
          path={"/products"}
          element={
            <Parameters
              page="Products"
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              overrideId={overrideId()}
              workspaceData={workspaceData}
              masterData={masterData}
            />
          }
        />
        <Route
          path={"/packs"}
          element={
            <Parameters
              page="Packs"
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              overrideId={overrideId()}
              workspaceData={workspaceData}
              masterData={masterData}
            />
          }
        />
        <Route
          path={"/email"}
          element={
            <Parameters
              page="Email"
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              overrideId={overrideId()}
              workspaceData={workspaceData}
              masterData={masterData}
            />
          }
        />{" "}
        <Route
          path={"/extraction-ia"}
          element={
            <Parameters
              page="ExtractionIA"
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              overrideId={overrideId()}
              workspaceData={workspaceData}
              masterData={masterData}
            />
          }
        />
        <Route
          path={"/tags"}
          element={
            <Parameters
              page="Tags"
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              overrideId={overrideId()}
              workspaceData={workspaceData}
              masterData={masterData}
            />
          }
        />
        <Route
          path={"/perso"}
          element={
            <Parameters
              page="Perso"
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              overrideId={overrideId()}
              workspaceData={workspaceData}
              masterData={masterData}
            />
          }
        />
        <Route
          path={"/notifications"}
          element={
            <Parameters
              page="Notifications"
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              overrideId={overrideId()}
              workspaceData={workspaceData}
              masterData={masterData}
            />
          }
        />
        <Route
          path={"/invoices"}
          element={
            <Invoices
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              overrideId={overrideId()}
              workspaceData={workspaceData}
              masterData={masterData}
            />
          }
        />
        <Route
          path={"/newinvoicedraft"}
          element={
            <NewInvoiceDraft
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              workspaceData={workspaceData}
              masterData={masterData}
              overrideId={overrideId()}
            />
          }
        />{" "}
        <Route
          path={"/newinvoicefromdraft/:id"}
          element={
            <NewInvoiceFromDraft
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              workspaceData={workspaceData}
              masterData={masterData}
              overrideId={overrideId()}
            />
          }
        />
        <Route
          path={"/invoice/:id"}
          element={
            <Invoice
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              workspaceData={workspaceData}
              masterData={masterData}
            />
          }
        />
        <Route
          path={"/forum"}
          element={
            <Forum
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              workspaceData={workspaceData}
              masterData={masterData}
            />
          }
        />
        <Route
          path={"/ai"}
          element={
            <Assistant
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              workspaceData={workspaceData}
            />
          }
        />
        <Route
          path={"/messages"}
          element={
            <Messages
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              workspaceData={workspaceData}
            />
          }
        />{" "}
        <Route
          path={"/bookshelf"}
          element={
            <Parameters
              page="BookShelf"
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              overrideId={overrideId()}
              workspaceData={workspaceData}
              masterData={masterData}
            />
          }
        />{" "}
        <Route
          path={"/bookshelfclient"}
          element={
            <Parameters
              page="BookShelf"
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              overrideId={overrideId()}
              workspaceData={workspaceData}
              masterData={masterData}
            />
          }
        />
        <Route
          path="/admin/*"
          element={
            <ProtectedRoute
              requiredRole={"admin"}
              navigateWorkspace={navigateWorkspace}
            >
              <AdminRoutes
                navigateWorkspace={navigateWorkspace}
                handleLoginAs={handleLoginAs}
                userData={userData}
                orgData={orgData}
              />
            </ProtectedRoute>
          }
        />
        <Route
          path="*"
          element={
            <NotFound
              navigateWorkspace={navigateWorkspace}
              actualpage={actualpage}
              version={version}
            />
          }
        />
      </Routes>
    </div>
  );
};

export default OldRoutes;
